import * as coreEntities from '_core/store/index';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function useSystemSettings() {
  const settings = useSelector((state) => coreEntities.systemSettings.selectors.getSystemSettings(state));
  const [loading, setLoading] = useState(true);
  const [enableAdvancedProgramming, setEnableAdvancedProgramming] = useState(undefined);
  const [enableEvaluationModel, setEnableEvaluationModel] = useState(undefined);

  useEffect(() => {
    if (settings) {
      setEnableAdvancedProgramming(settings?.enable_advanced_programming === 1);
      setEnableEvaluationModel(settings?.enable_evaluation_model === 1);
      setLoading(false);
    }
  }, [settings]);

  return { enableAdvancedProgramming, enableEvaluationModel, loadingSettings: loading };
}

export default useSystemSettings;
